import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiUrl } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Tenant } from '../models/tenant';
import { AuthService, CacheService, IHasKey } from '@kpd/framework-ngx';
import { Observable } from 'rxjs';

export interface ITenantDTO {
  authenticationProviders: number;
  applications: [
    {
      name: string;
      roles: [
        {
          isAssignedByDefault: boolean;
          name: string;
        }
      ];
    }
  ];
  name: string;
  description: string;
  id: string;
}

@Injectable()
export class TenantService {
  tenant: IHasKey;
  constructor(private httpClient: HttpClient, authService: AuthService, private cache: CacheService) {
    this.tenant = authService.getTenant();
  }

  getTenant(): Observable<Tenant> {
    const tenant$ = this.httpClient
      .get<ITenantDTO>(`${apiUrl()}/tenants/${this.tenant.key}`)
      .pipe(map(tenantDTO => new Tenant(tenantDTO)));
    if (this.cache) {
      return this.cache.get(`CurrentTenant`, tenant$, 2592000000);
    }
    return tenant$;
  }

  getAllTenantsForCurrentUser(): Observable<Tenant[]> {
    return this.httpClient
      .get<ITenantDTO[]>(`${apiUrl()}/token/tenants/`)
      .pipe(map(tenantDTOs => tenantDTOs.map(tenantDTO => new Tenant(tenantDTO))));
  }
}
